<!-- src\components\dashboard\mainDashboard.vue -->
<template>
  <!-- Importacion de vue-sonner -->
  <Toaster position="top-center" richColors closeButton />
  <MetricasLocal :empresa-id="local?.id_empresa" :local-id="local?.id" :use-backend="true" :auto-refresh="true" :refresh-interval="200000" @operatividad-actualizada="refrescarOperatividadPlano" />
  <div class="mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 p-1 bg-white rounded-lg border border-efintelwhite-55">

      <div class="space-y-4">
        <div class="flex items-center space-x-4 p-2 bg-white rounded-lg">
          <div class="w-12 h-12 rounded-lg flex items-center justify-center">
            <img v-if="localCompleto?.media" :src="localCompleto?.media" class="w-full h-full object-cover" alt="Logo">
          </div>
          <div>
            <h3 class="text-lg font-semibold text-gray-900">Local N° {{ localCompleto?.numero_local || 'Sin número' }}
            </h3>
            <p class="text-sm text-gray-500">
              {{ empresaInfo?.nombre_empresa || 'Sin empresa' }}
            </p>
          </div>
        </div>
        <p class="text-sm font-semibold text-gray-900 text-left px-2">Contactos de Tienda</p>

        <div v-if="loadingEmpresas || loadingEncargado" class="text-center py-4">
          <div class="inline-flex items-center space-x-2 text-sm text-gray-500">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
            <span>{{ loadingEncargado ? 'Cargando datos del encargado...' : 'Cargando contactos...' }}</span>
          </div>
        </div>

        <div v-if="errorEncargado && !loadingEncargado" class="bg-red-50 border border-red-200 rounded-lg p-4">
          <div class="flex items-center space-x-2">
            <svg class="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
            </svg>
            <span class="text-sm text-red-700">Error cargando encargado: {{ errorEncargado }}</span>
          </div>
        </div>
        <div v-if="localCompleto && !loadingEncargado && !loadingEmpresas" class="bg-white rounded-lg overflow-hidden">
          <table class="min-w-full">
            <thead class="bg-white border-b border-gray-200">
              <tr>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contacto</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cargo</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Teléfono</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr class="bg-gray-25 hover:bg-gray-50 transition-colors">
                <td class="px-4 py-4">
                  <div class="flex items-center space-x-3">
                    <div>
                      <div class="text-sm font-medium text-gray-900">{{ empresaInfo?.nombre_empresa || 'Sin empresa' }}
                      </div>
                    </div>
                  </div>
                </td>
                <td class="px-4 py-4 text-sm text-gray-600">
                  Establecimiento
                </td>
                <td class="px-4 py-4 text-xs text-gray-900">
                  <div class="flex items-center space-x-1">
                    <span class="whitespace-nowrap">{{ formatearTelefono(empresaInfo?.telefono_empresa) || 'Contactar encargado' }}</span>
                  </div>
                </td>
                <td class="px-4 py-4 text-sm">
                  <a v-if="empresaInfo?.email_empresa" :href="`mailto:${empresaInfo.email_empresa}`" class="inline-flex items-center space-x-1 text-blue-600 hover:text-blue-800 hover:underline">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 002 2z"></path>
                    </svg>
                    <span>{{ empresaInfo.email_empresa }}</span>
                  </a>
                  <span v-else class="text-gray-500">Ver encargado</span>
                </td>
              </tr>
              <tr class="hover:bg-blue-50 transition-colors">
                <td class="px-4 py-4">
                  <div class="flex items-center space-x-3">
                    <div>
                      <div class="text-sm font-medium text-gray-900">
                        {{ encargadoLocal?.nombre_completo || 'Sin asignar' }}
                      </div>
                    </div>
                  </div>
                </td>
                <td class="px-4 py-4 text-sm text-gray-600">
                  {{ encargadoLocal?.cargo || 'Encargado Local' }}
                </td>
                <td class="px-4 py-4 text-xs text-gray-900">
                  <div class="flex items-center space-x-1">
                    <span class="whitespace-nowrap">{{ formatearTelefono(encargadoLocal?.telefono) }}</span>
                  </div>
                </td>
                <td class="px-4 py-4 text-sm">
                  <a v-if="encargadoLocal?.email && encargadoLocal.email !== 'No disponible'" :href="`mailto:${encargadoLocal.email}`" class="inline-flex items-center space-x-1 text-blue-600 hover:text-blue-800 hover:underline">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 002 2z"></path>
                    </svg>
                    <span>{{ encargadoLocal.email }}</span>
                  </a>
                  <div v-else class="flex items-center space-x-1 text-gray-500">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 5v14m7-7H5">
                      </path>
                    </svg>
                    <span>No disponible</span>
                  </div>
                </td>
              </tr>
              <tr v-if="loadingEncargadosExtras">
                <td colspan="4" class="px-4 py-6 text-center">
                  <div class="inline-flex items-center space-x-2 text-sm text-gray-500">
                    <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                    <span>Cargando encargados adicionales...</span>
                  </div>
                </td>
              </tr>
              <tr v-else-if="errorEncargadosExtras">
                <td colspan="4" class="px-4 py-4">
                  <div class="bg-red-50 border border-red-200 rounded-lg p-3">
                    <div class="flex items-center space-x-2">
                      <svg class="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                      </svg>
                      <span class="text-sm text-red-700">{{ errorEncargadosExtras }}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-else v-for="(encargadoExtra, index) in encargadosExtrasDelLocal" :key="`extra-${encargadoExtra.id || index}`" class="bg-blue-25 hover:bg-blue-50 transition-colors">

                <td class="px-4 py-4">
                  <div class="flex items-center space-x-3">
                    <div>
                      <div class="text-sm font-medium text-gray-900">
                        {{ encargadoExtra.nombre }}
                      </div>
                    </div>
                  </div>
                </td>

                <td class="px-4 py-4 text-sm text-gray-600">
                  {{ encargadoExtra.cargo || 'Sin especificar' }}
                </td>

                <td class="px-4 py-4 text-xs text-gray-900">
                  <div v-if="encargadoExtra.telefono" class="flex items-center space-x-1">
                    <span class="whitespace-nowrap">{{ formatearTelefono(encargadoLocal?.telefono) }}</span>
                  </div>
                  <div v-else class="flex items-center space-x-1 text-gray-500">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 5v14m7-7H5">
                      </path>
                    </svg>
                    <span>No disponible</span>
                  </div>
                </td>

                <td class="px-4 py-4 text-sm">
                  <a v-if="encargadoExtra.email" :href="`mailto:${encargadoExtra.email}`" class="inline-flex items-center space-x-1 text-blue-600 hover:text-blue-800 hover:underline">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 002 2z"></path>
                    </svg>
                    <span>{{ encargadoExtra.email }}</span>
                  </a>
                  <div v-else class="flex items-center space-x-1 text-gray-500">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 5v14m7-7H5">
                      </path>
                    </svg>
                    <span>No disponible</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else-if="!loadingEmpresas && !loadingEncargado" class="bg-white rounded-lg p-12 text-center border border-gray-100">
          <svg class="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
          <p class="text-gray-600 font-medium">Selecciona un local</p>
          <p class="text-sm text-gray-400">Para ver los contactos del personal</p>
        </div>

        <div v-if="loading" class="text-center py-6">
          <div class="inline-flex items-center space-x-2">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
            <span class="text-gray-600 text-sm">Cargando información...</span>
          </div>
        </div>
      </div>
      <div>
        <LocalGPS :local="localCompleto" :nombre-empresa="empresaInfo?.nombre_empresa" :permitir-edicion="true" @gps-loaded="onGPSLoaded" @gps-error="onGPSError" @location-shared="onLocationShared" @edit-requested="onEditLocalRequested" @help-requested="onHelpRequested" />
      </div>
    </div>
    <!-- Seccion de Plano de dispositivos por local (si tiene plano cargado desde la edicion/creacion del local) -->
    <PlanoLocalView ref="planoLocalRef" :local-id="local?.id" :equipos="equipos" /> <!-- Acordarme de agregar v-if="false" para que no aparezca en produccion -->
    <!-- Seccion de Consumo energetico del local -->
    <ConsumoLocal :local-id="local?.id" />
    <div class="bg-gray-50 border-gray-200 px-1 py-3 flex-shrink-0">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 items-center">
        <!-- Búsqueda: ocupa 2 columnas en lg, y en móvil ocupa ambas -->
        <div class="sm:col-span-2 lg:col-span-2">
          <div class="relative">
            <input v-model="searchText" type="text" placeholder="Buscar por nombre, zona o modo..." class="w-full pl-9 pr-9 h-9 text-sm border border-gray-300 rounded-lg bg-white shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors" />
            <svg class="absolute left-3 top-2.5 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <button v-if="searchText" @click="searchText = ''" class="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Dropdown estado -->
        <div class="relative">
          <button @click="toggleDropdown('estado')" class="w-full h-9 px-3 text-sm bg-white border border-gray-300 rounded-lg shadow-sm hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-left flex items-center justify-between">
            <span class="text-gray-700 truncate">
              {{ filtroEstado === 'TODOS' ? 'Todos' : (filtroEstado === 'ACTIVOS' ? 'En Línea' : 'Desconectados') }}
            </span>
            <svg :class="['w-4 h-4 text-gray-400 transition-transform', dropdownOpen.estado ? 'rotate-180' : '']" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <div v-if="dropdownOpen.estado" class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg overflow-hidden">
            <button @click="selectOption('estado', 'TODOS')" class="w-full px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors">
              Todos
            </button>
            <button @click="selectOption('estado', 'ACTIVOS')" class="w-full px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors">
              En Línea
            </button>
            <button @click="selectOption('estado', 'INACTIVOS')" class="w-full px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors">
              Desconectados
            </button>
          </div>
        </div>

        <!-- Botón Agregar Dispositivo -->
        <div class="flex items-center">
          <button v-if="puedeCrearDispositivo" @click="handleAnadirDispositivo" class="w-full h-9 px-3 bg-white border border-emerald-600 rounded-lg text-sm font-medium text-black group relative overflow-hidden transition-all duration-300 hover:border-emerald-600" type="button">
            <div class="relative z-10 flex items-center justify-center h-full transition-colors duration-300 group-hover:text-white">
              <svg class="w-4 h-4 mr-1.5 transition-transform duration-300 group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
              <span>Agregar Dispositivo</span>
            </div>
            <!-- Overlay animado (verde que se expande) -->
            <div class="absolute inset-0 bg-emerald-600 rounded-lg transform scale-x-0 origin-left transition-transform duration-300 ease-out group-hover:scale-x-100 pointer-events-none"></div>
          </button>
        </div>
      </div>

      <!-- Contador y limpiar filtros -->
      <div class="flex justify-end mt-2 text-xs text-gray-500">
        <div class="flex items-center">
          <span>Se muestran <span class="font-medium text-gray-700">{{ equiposProcesados.length }}</span> dispositivos</span>
          <button v-if="hasActiveFilters" @click="clearAllFilters" class="text-red-600 hover:text-red-800 font-medium transition-colors">
            Limpiar filtros
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Tabla de dispositivos -->
  <div class="bg-efintelwhite-50 px-4 sm:px-6 lg:px-8 pb-6">
    <div class="bg-white rounded-lg shadow-sm border border-efintelwhite-55 overflow-hidden">

      <div class="hidden lg:block overflow-x-auto">
        <table class="min-w-full divide-y">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Imagen</th>

              <th @click="cambiarOrden('nombre_dispositivo')" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors select-none">
                <div class="flex items-center space-x-1">
                  <span>Nombre</span>
                  <svg v-if="columnaOrden === 'nombre_dispositivo'" :class="{ 'rotate-180': ordenDescendente }" class="w-4 h-4 transition-transform text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
                  </svg>
                </div>
              </th>

              <th @click="cambiarOrden('ubicacion')" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors select-none">
                <div class="flex items-center space-x-1">
                  <span>Zona</span>
                  <svg v-if="columnaOrden === 'ubicacion'" :class="{ 'rotate-180': ordenDescendente }" class="w-4 h-4 transition-transform text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
                  </svg>
                </div>
              </th>

              <th @click="cambiarOrden('en_linea')" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors select-none">
                <div class="flex items-center space-x-1">
                  <span>Comunicación</span>
                  <svg v-if="columnaOrden === 'en_linea'" :class="{ 'rotate-180': ordenDescendente }" class="w-4 h-4 transition-transform text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
                  </svg>
                </div>
              </th>

              <th @click="cambiarOrden('modo')" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors select-none">
                <div class="flex items-center space-x-1">
                  <span>Modo</span>
                  <svg v-if="columnaOrden === 'modo'" :class="{ 'rotate-180': ordenDescendente }" class="w-4 h-4 transition-transform text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
                  </svg>
                </div>
              </th>

              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">T° Inyección</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">T° Retorno</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
            </tr>
          </thead>

          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-for="(equipo) in equiposProcesados" :key="equipo.id" @click="abrirDetalleEquipo(equipo.id)" class="hover:bg-gray-50 transition-colors cursor-pointer">
              <!-- <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ index + 1 }}
              </td> -->

              <td class="px-6 py-4 whitespace-nowrap">
                <div class="w-12 h-12 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
                  <img :src="equipo.imagen" :alt="equipo.nombre_dispositivo" class="w-full h-full object-cover" @error="$event.target.src = resolverImagen('ImagenDefault')" />
                </div>
              </td>

              <td class="px-6 py-4 whitespace-nowrap">
                <div class="flex items-center">
                  <div>
                    <div class="text-sm font-medium text-gray-900">
                      {{ equipo.nombre_dispositivo || 'Dispositivo sin nombre' }}
                    </div>
                  </div>
                </div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm" :class="equipo.activo_dispositivo ? 'text-gray-900' : 'text-gray-900'">
                {{ equipo.ubicacion_dispositivo || equipo.nombre_dispositivo }}
              </td>

              <td class="px-6 py-4 whitespace-nowrap">
                <div class="flex items-center">
                  <div :class="[
                    'w-3 h-3 rounded-full mr-2',
                    equipo.en_linea ? 'bg-green-500' : 'bg-red-800 animate-pulse'
                  ]"></div>

                  <span :class="[
                    'text-sm font-medium',
                    equipo.en_linea ? 'text-green-700' : 'text-red-800'
                  ]">
                    {{ equipo.en_linea ? 'Activo' : 'Inactivo' }}
                  </span>
                </div>
              </td>

              <td class="px-6 py-4 whitespace-nowrap">
                <div class="flex items-center">
                  <svg v-if="equipo.modo_obtencion === 'OFF'" class="w-4 h-4 text-gray-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z" clip-rule="evenodd" />
                  </svg>

                  <svg v-else-if="equipo.modo_obtencion === 'FRIO'" class="w-4 h-4 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l-1 1v3l-3-3-1.5 1.5 3 3H6l-1 1 1 1h3.5l-3 3L8 14l3-3v3.5l1 1 1-1V11l3 3 1.5-1.5-3-3H18l1-1-1-1h-3.5l3-3L16 4l-3 3V3.5z" />
                  </svg>

                  <svg v-else-if="equipo.modo_obtencion === 'CALOR'" class="w-4 h-4 text-orange-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
                  </svg>

                  <svg v-else-if="equipo.modo_obtencion === 'VENTILACIÓN'" class="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                  </svg>

                  <svg v-else class="w-4 h-4 text-gray-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                  </svg>

                  <span :class="[
                    'text-sm font-medium',
                    equipo.modo_obtencion === 'OFF' ? 'text-gray-600' :
                      equipo.modo_obtencion === 'FRIO' ? 'text-blue-700' :
                        equipo.modo_obtencion === 'CALOR' ? 'text-orange-700' :
                          equipo.modo_obtencion === 'VENTILACIÓN' ? 'text-cyan-700' : 'text-gray-700'
                  ]">
                    {{ equipo.modo_obtencion || 'Desconocido' }}
                  </span>
                </div>
              </td>

              <td class="px-6 py-4 whitespace-nowrap">
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                  {{ obtenerTemperaturaRender(equipo, 'Temp Inyeccion') }}
                </span>
              </td>

              <td class="px-6 py-4 whitespace-nowrap">
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                  {{ obtenerTemperaturaRender(equipo, 'Temp Retorno') }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm">
                <div class="flex items-center space-x-2">
                  <button v-if="puedeEliminarDispositivo" @click.stop="iniciarEliminacionDispositivo(equipo)" class="group relative p-2 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all duration-300" title="Eliminar dispositivo">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="equipos.length === 0">
              <td colspan="9" class="px-6 py-12 text-center">
                <div class="text-gray-500">
                  <svg class="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z">
                    </path>
                  </svg>
                  <p class="text-lg font-medium text-gray-900 mb-2">No hay dispositivos</p>
                  <p class="text-sm">{{ loadingDispositivos ? 'Cargando dispositivos...' : 'No se encontraron dispositivos conectados' }}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="lg:hidden divide-y divide-gray-200">
        <div v-for="(equipo, index) in equipos" :key="equipo.id" @click="abrirDetalleEquipo(equipo.id)" class="p-4 hover:bg-gray-50 transition-colors cursor-pointer">

          <div class="flex items-start justify-between mb-3">
            <div class="flex items-center space-x-3 flex-1">
              <div class="w-14 h-14 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center flex-shrink-0">
                <img :src="equipo.imagen" :alt="equipo.nombre_dispositivo" class="w-full h-full object-cover" @error="$event.target.src = resolverImagen('ImagenDefault')" />
              </div>
              <div class="flex-1 min-w-0">
                <h3 class="font-semibold text-gray-900 truncate">
                  {{ equipo.nombre_dispositivo || 'Dispositivo sin nombre' }}
                </h3>
                <p class="text-xs text-gray-500 truncate">{{ equipo.ubicacion_dispositivo || equipo.nombre_dispositivo
                }}</p>
              </div>
            </div>

            <div class="flex items-center ml-2 flex-shrink-0">
              <div :class="['w-2 h-2 rounded-full mr-1', equipo.en_linea ? 'bg-green-500' : 'bg-red-800']"></div>
              <span :class="['text-xs font-medium', equipo.en_linea ? 'text-green-700' : 'text-red-800']">
                {{ equipo.en_linea ? 'Activo' : 'Inactivo' }}
              </span>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-3 mb-3">
            <div class="bg-gray-50 rounded-lg p-2">
              <p class="text-xs text-gray-500 mb-1">Modo</p>
              <div class="flex items-center">
                <svg v-if="equipo.modo_obtencion === 'OFF'" class="w-4 h-4 text-gray-400 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z" clip-rule="evenodd" />
                </svg>
                <svg v-else-if="equipo.modo_obtencion === 'FRIO'" class="w-4 h-4 text-blue-500 mr-1" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2l-1 1v3l-3-3-1.5 1.5 3 3H6l-1 1 1 1h3.5l-3 3L8 14l3-3v3.5l1 1 1-1V11l3 3 1.5-1.5-3-3H18l1-1-1-1h-3.5l3-3L16 4l-3 3V3.5z" />
                </svg>
                <svg v-else-if="equipo.modo_obtencion === 'CALOR'" class="w-4 h-4 text-orange-500 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
                </svg>
                <svg v-else-if="equipo.modo_obtencion === 'VENTILACIÓN'" class="w-4 h-4 text-green-500 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                </svg>
                <span class="text-sm font-medium text-gray-900 truncate">
                  {{ equipo.modo_obtencion || 'N/A' }}
                </span>
              </div>
            </div>

            <div class="bg-gray-50 rounded-lg p-2">
              <p class="text-xs text-gray-500 mb-1">N°</p>
              <p class="text-sm font-semibold text-gray-900">{{ index + 1 }}</p>
            </div>

            <div class="bg-gray-50 rounded-lg p-2">
              <p class="text-xs text-gray-500 mb-1">T° Inyección</p>
              <p class="text-sm font-semibold text-gray-900">
                {{ obtenerTemperaturaRender(equipo, 'Temp Inyeccion') }}
              </p>
            </div>

            <div class="bg-gray-50 rounded-lg p-2">
              <p class="text-xs text-gray-500 mb-1">T° Retorno</p>
              <p class="text-sm font-semibold text-gray-900">
                {{ obtenerTemperaturaRender(equipo, 'Temp Retorno') }}
              </p>
            </div>
          </div>

          <div v-if="puedeEliminarDispositivo" class="flex justify-end">
            <button @click.stop="iniciarEliminacionDispositivo(equipo)" class="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
        </div>

        <div v-if="equipos.length === 0" class="p-8 text-center">
          <svg class="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z">
            </path>
          </svg>
          <p class="text-base font-medium text-gray-900 mb-2">No hay dispositivos</p>
          <p class="text-sm text-gray-500">{{ loadingDispositivos ? 'Cargando...' : 'No se encontraron dispositivos' }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showDeleteModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-70 p-4">
    <div class="bg-white rounded-lg w-full max-w-lg max-h-[90vh] overflow-y-auto">

      <div class="bg-gradient-to-r from-red-600 to-red-700 text-white p-4 rounded-t-lg">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 rounded-full bg-red-500 flex items-center justify-center">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </div>
            <div>
              <h3 class="text-xl font-bold">Eliminar Dispositivo</h3>
              <p class="text-red-100 text-sm">Esta acción no se puede deshacer</p>
            </div>
          </div>
          <button @click="hideDeleteModal" :disabled="processingDelete" class="w-8 h-8 rounded-full bg-red-500 hover:bg-red-600 flex items-center justify-center transition-colors disabled:opacity-50">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <div class="p-6">

        <div v-if="loadingDeleteInfo" class="text-center py-8">
          <svg class="animate-spin h-8 w-8 text-red-600 mx-auto mb-4" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
          </svg>
          <p class="text-gray-600">Verificando dispositivo...</p>
        </div>

        <div v-else-if="deleteInfo" class="space-y-6">

          <div class="bg-red-50 border border-red-200 rounded-lg p-4">
            <div class="flex items-start space-x-3">
              <svg class="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.732 15.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
              <div class="flex-1">
                <h4 class="font-semibold text-red-800 mb-2">⚠️ Confirmar eliminación</h4>
                <p class="text-red-700 mb-3">
                  Esta acción eliminará permanentemente el dispositivo y todos sus datos históricos.
                </p>

                <div class="bg-white rounded border p-3 space-y-2 text-sm">
                  <div class="flex justify-between">
                    <span class="text-gray-600">Nombre:</span>
                    <span class="font-medium">{{ deleteInfo.dispositivo.nombre_dispositivo }}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-gray-600">Ubicación:</span>
                    <span class="font-medium">{{ deleteInfo.dispositivo.ubicacion_dispositivo || 'Sin definir' }}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-gray-600">Modelo:</span>
                    <span class="font-medium">{{ deleteInfo.dispositivo.modelo_dispositivo || 'IC270' }}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-gray-600">Estado:</span>
                    <span :class="deleteInfo.dispositivo.activo_dispositivo ? 'text-green-600' : 'text-gray-600'" class="font-medium">
                      {{ deleteInfo.dispositivo.activo_dispositivo ? 'Activo' : 'Inactivo' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="space-y-3">
            <div class="border border-gray-200 rounded-lg p-3 bg-gray-50">
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Para confirmar, escribe "<strong>{{ deleteInfo.dispositivo.nombre_dispositivo }}</strong>" en el campo:
              </label>
              <input v-model="deleteConfirmationText" type="text" :placeholder="`Escribe ${deleteInfo.dispositivo.nombre_dispositivo} para confirmar`" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors" :class="isDeleteConfirmationValid ? 'border-green-500 bg-green-50' : ''">
            </div>
          </div>

          <div class="flex items-center justify-end space-x-3">
            <button type="button" @click="hideDeleteModal" :disabled="processingDelete" class="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors disabled:opacity-50">
              Cancelar
            </button>

            <button @click="confirmarEliminacion" :disabled="processingDelete || !isDeleteConfirmationValid" class="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2">
              <svg v-if="processingDelete" class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                </path>
              </svg>
              <span>{{ processingDelete ? 'Eliminando...' : 'Eliminar Dispositivo' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalDetalleDispositivo ref="modalDetalleDispositivo" :visible="modalAbierto" :dispositivo="equipoSeleccionado" :hay-equipo-anterior="hayEquipoAnterior" :hay-equipo-siguiente="hayEquipoSiguiente" :cargando-navegacion="cargandoNavegacion" :local-completo="localCompleto" @cerrar="cerrarModal" @ver-equipo-anterior="verEquipoAnterior" @ver-equipo-siguiente="verEquipoSiguiente" @edicion-nombre-iniciada="editandoNombre = true" @campo-guardado="manejarCampoGuardado" @nombre-guardado="guardarNombreDispositivo($event)" @ubicacion-guardada="guardarUbicacionDispositivo($event)" @toggle-power="togglePower" @incrementar-temp="incrementTemp" @decrementar-temp="decrementTemp" @abrir-modal-horario="abrirModalHorario" @exportar-pdf="exportarPDF" @imagen-actualizada="actualizarImagenDispositivo" @imagen-eliminada="eliminarImagenDispositivo">
    <template #grafico-historial>
      <GraficoHistorial ref="graficoHistorial" :dispositivo="equipoSeleccionado" :configuracion="configuracionGrafico" @datos-filtrados="onGraficoDatosFiltrados" @variable-seleccionada="onGraficoVariableSeleccionada" @exportar-solicitado="onGraficoExportarSolicitado" />
    </template>

    <template #alertas-dispositivo>
      <AlertasDispositivo v-if="equipoSeleccionado && equipoSeleccionado.id" :dispositivo-id="equipoSeleccionado.id" :auto-refresh="true" :refresh-interval="30000" />
      <div v-else class="flex items-center justify-center py-8 text-gray-500">
        <svg class="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        Cargando alertas...
      </div>
    </template>
  </ModalDetalleDispositivo>
  <AlarmasView :is-open="modalAlarmasAbierto" @close="cerrarModalAlarmas" />
  <ModalConfiguracionHorarios :visible="modalHorarioAbierto" :equipo="equipoSeleccionado" :configuracion-inicial="configuracionHorarios" @close="cerrarModalHorario" @save="guardarConfiguracionHorarios" />
  <ModalGestionDispositivos :visible="showDispositivosModal" :local="localCompleto" :mode="'create'" @close="showDispositivosModal = false" @dispositivo-created="onDispositivoCreado" />
</template>

<script>
import ImagenDefault from '@/assets/ImagenDefaultDispositivos.png'
import { toast } from 'vue-sonner'

// Servicios Adiconales
import DispositivosService from '@/services/dispositivos/dispositivos.js'
import { sensorMap, getNumber } from '@/services/utils/sensores.js'
// import AuthService from '@/services/auth.js'
import EncargadosExtrasService from '@/services/usuarios/encargadosExtras.js'
import UsuariosService from '@/services/usuarios/usuarios.js'
import PermissionsService from '@/services/auth/permissions.js'
// Componentes Adicionales
import PlanoLocalView from '@/components/locales/PlanoLocalView.vue'
import LocalGPS from '@/components/map/LocalGPS.vue'
import GraficoHistorial from '@/components/charts/GraficoHistorial.vue'
import ModalConfiguracionHorarios from '@/components/dispositivos/ModalConfiguracionHorarios.vue'
import AlertasDispositivo from '@/components/dispositivos/AlertasDispositivo.vue'
import ModalGestionDispositivos from '@/components/dispositivos/ModalGestionDispositivos.vue'
import ModalDetalleDispositivo from '@/components/dispositivos/ModalDetalleDispositivo.vue'
import AlarmasView from '@/components/dashboard/AlarmasView.vue'
import MetricasLocal from '@/components/dashboard/metricasLocal.vue'
import ConsumoLocal from '@/components/locales/consumoLocal.vue'
// Funciones auxiliares
function modoTexto(valorModo) {
  const map = { 0: "OFF", 1: "FRIO", 2: "CALOR", 3: "VENTILACION" };
  return map[Number(valorModo)] || "OFF";
}

export default {
  name: 'MainDashboard',
  components: {
    ModalConfiguracionHorarios,
    ModalGestionDispositivos,
    LocalGPS,
    AlertasDispositivo,
    GraficoHistorial,
    ModalDetalleDispositivo,
    AlarmasView,
    MetricasLocal,
    PlanoLocalView,
    ConsumoLocal
  },

  props: {
    local: {
      type: Object,
      default: null
    },
    empresa: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      loading: false,
      modalAbierto: false,
      modalHorarioAbierto: false,
      modalAlarmasAbierto: false, // Estado para el modal de alarmas
      loadingDispositivos: false,
      errorDispositivos: null,
      ultimaActualizacion: null,
      reintentoCount: 0,
      autoUpdateEnabled: true,
      updateInterval: null,
      updateFrequency: 30000, // 30 segundos
      clienteSeleccionadoId: '',
      empresaSeleccionada: null,
      // ESTADOS PARA USUARIOS
      loadingEmpresas: false,
      encargadoLocal: null,
      loadingEncargado: false,
      errorEncargado: null,
      encargadosCache: new Map(), // Caché para no volver a pedir usuarios
      encargadosExtrasDelLocal: [],
      loadingEncargadosExtras: false,
      errorEncargadosExtras: null,
      // ESTADOS PARA ELIMINACIÓN
      showDeleteModal: false,
      processingDelete: false,
      loadingDeleteInfo: false,
      deleteInfo: null,
      dispositivoToDelete: null,
      deleteConfirmationText: '',
      // Estados para la navegación en el modal de detalle
      indiceEquipoActual: -1,
      navegacionHistorial: [],
      cargandoNavegacion: false,
      showDispositivosModal: false,
      editandoNombre: false,              // Controla si está en modo edición
      nombreTemporal: '',                 // Nombre temporal mientras se edita
      guardandoNombre: false,             // Estado de carga al guardar
      escapeListener: null,
      dispositivoSeleccionado: null,
      searchText: '',
      filtroEstado: 'TODOS',
      columnaOrden: 'nombre_dispositivo',
      ordenDescendente: false,
      dropdownOpen: {
        estado: false
      },
      // ESTADOS PARA GRAFICOS
      configuracionGrafico: {
        mostrarValoresActuales: true,
        intervaloActualizacion: 30000
      },
      // CONFIGURACIÓN DE HORARIOS
      configuracionHorarios: {
        habilitadorPrincipal: true,
        manana: {
          desde: '07:00',
          hasta: '11:30',
          modo: 'CALOR',
          habilitado: true
        },
        tarde: {
          desde: '14:00',
          hasta: '21:10',
          modo: 'FRIO',
          habilitado: true
        },
        noche: {
          desde: '00:00',
          hasta: '04:50',
          modo: 'CALOR',
          habilitado: false
        },
      },

      // Datos de clientes (placeholder)
      clientes: [
        {
          id: 'juan-pablo',
          nombre: 'Juan Pablo Erices',
          rut: '21.351.502-0',
          email: 'ejemploejemplo@gmail.com',
          telefono: '948901554',
          direccion: 'Los Ángeles Sur',
          stlFile: '/assets/models/planta-juan-erices.stl',
        },
        {
          id: 'maria-gonzalez',
          nombre: 'María González',
          rut: '11.345.999-9',
          email: 'maria.gonzalez@email.com',
          telefono: '987654321',
          direccion: 'Santiago Centro',
          imagen: null
        },
        {
          id: 'carlos-lopez',
          nombre: 'Carlos López',
          rut: '19.999.999-9',
          email: 'carlos.lopez@email.com',
          telefono: '956789123',
          direccion: 'Valparaíso',
          imagen: null
        }
      ],

      // Array de modos (debe coincidir con el servicio)
      modoDispositivo: [
        { id: 0, nombre: 'OFF' },
        { id: 1, nombre: 'FRIO' },
        { id: 2, nombre: 'CALOR' },
        { id: 3, nombre: 'VENTILACIÓN' },
      ],

      // Objeto para el equipo seleccionado en el modal
      equipoSeleccionado: {
        id: null,
        nombre_dispositivo: '',
        modelo_dispositivo: '',
        ubicacion_dispositivo: '',
        activo_dispositivo: false,
        configuracion_dispositivo: {},
        modo_obtencion: '',
        nombre: '',
        ubicacion: '',
        encendido: false,
        modo: '',
        potenciaActiva: 0,
        tempRetorno: 0,
        tempObjetivo: 0,
        fabricante: '',
        ultimoMantenimiento: '',
        bateria: 0,
        consumo: 0,
        voltajes: {},
        corrientes: {},
        historialVoltajes: [],
        alertas: []
      },

      // Lista principal de equipos (se llena desde el backend)
      equipos: [],

      // Configuración de debug y fallback
      debugMode: process.env.NODE_ENV === 'development',
      networkTimeout: 30000,
      maxRetryAttempts: 3,
      tiempoUltimaCarga: null,
      errorConsecutivos: 0,

      // ESTADO DE CONEXIÓN TIEMPO REAL
      conexionTiempoReal: false,
      ultimoHeartbeat: null,
      intentosReconexion: 0
    }
  },

  computed: {
    hasActiveFilters() {
      return this.searchText.trim() !== '' || this.filtroEstado !== 'TODOS';
    },

    equiposProcesados() {
      let resultado = [...this.equipos];

      // 1. Filtro por Búsqueda de Texto
      if (this.searchText.trim() !== '') {
        const search = this.searchText.toLowerCase();
        resultado = resultado.filter(e =>
          (e.nombre_dispositivo && e.nombre_dispositivo.toLowerCase().includes(search)) ||
          (e.ubicacion_dispositivo && e.ubicacion_dispositivo.toLowerCase().includes(search)) ||
          (e.modo_obtencion && e.modo_obtencion.toLowerCase().includes(search))
        );
      }

      // 2. Filtro por Estado
      if (this.filtroEstado === 'ACTIVOS') {
        resultado = resultado.filter(e => e.en_linea === true);
      } else if (this.filtroEstado === 'INACTIVOS') {
        resultado = resultado.filter(e => e.en_linea === false);
      }

      // 3. Aplicar Ordenamiento
      resultado.sort((a, b) => {
        let valA, valB;
        switch (this.columnaOrden) {
          case 'nombre_dispositivo':
            valA = a.nombre_dispositivo || '';
            valB = b.nombre_dispositivo || '';
            break;
          case 'ubicacion':
            valA = a.ubicacion_dispositivo || a.nombre_dispositivo || '';
            valB = b.ubicacion_dispositivo || b.nombre_dispositivo || '';
            break;
          case 'en_linea':
            valA = a.en_linea ? 1 : 0;
            valB = b.en_linea ? 1 : 0;
            break;
          case 'modo':
            valA = a.modo_obtencion || '';
            valB = b.modo_obtencion || '';
            break;
          default:
            valA = a[this.columnaOrden];
            valB = b[this.columnaOrden];
        }

        if (typeof valA === 'string') valA = valA.toLowerCase();
        if (typeof valB === 'string') valB = valB.toLowerCase();

        if (valA < valB) return this.ordenDescendente ? 1 : -1;
        if (valA > valB) return this.ordenDescendente ? -1 : 1;
        return 0;
      });

      return resultado;
    },
    /**
     * Verifica si el usuario puede eliminar dispositivos
     */
    puedeEliminarDispositivo() {
      return PermissionsService.can('dispositivos', 'eliminar')
    },
    /**
     * Valida la confirmación de eliminación
     */
    isDeleteConfirmationValid() {
      return this.deleteInfo &&
        this.deleteConfirmationText.trim() === this.deleteInfo.dispositivo.nombre_dispositivo
    },
    // ========================================
    // PERMISOS COMPUTADOS
    // ========================================
    puedeCrearDispositivo() {
      return PermissionsService.can('dispositivos', 'crear')
    },
    // ========================================
    /**
     * Indica si hay un equipo anterior disponible
     */
    hayEquipoAnterior() {
      return this.indiceEquipoActual > 0 && this.equipos.length > 1
    },
    /**
     * Indica si hay un equipo siguiente disponible  
     */
    hayEquipoSiguiente() {
      return this.indiceEquipoActual < this.equipos.length - 1 && this.equipos.length > 1
    },
    /**
     * Obtiene el equipo anterior
     */
    equipoAnterior() {
      if (!this.hayEquipoAnterior) return null
      return this.equipos[this.indiceEquipoActual - 1]
    },

    /**
     * Obtiene el equipo siguiente
     */
    equipoSiguiente() {
      if (!this.hayEquipoSiguiente) return null
      return this.equipos[this.indiceEquipoActual + 1]
    },
    /**
     * Información de navegación para mostrar en UI
     */
    infoNavegacion() {
      if (this.equipos.length <= 1) return null

      return {
        actual: this.indiceEquipoActual + 1,
        total: this.equipos.length,
        porcentaje: Math.round(((this.indiceEquipoActual + 1) / this.equipos.length) * 100)
      }
    },
    /**
     * Información completa del local con datos del encargado
     */
    localCompleto() {
      if (!this.local) {
        return null;
      }

      // Datos base del local
      const localBase = {
        ...this.local,
        numero_local: this.local.numero_local,
        direccion: this.local.direccion,
        media: this.local.media
      };

      // Si tenemos encargado real del backend, combinarlo
      if (this.encargadoLocal) {
        return {
          ...localBase,
          //   DATOS REALES DEL ENCARGADO
          encargado: this.encargadoLocal.nombre_completo,
          encargado_email: this.encargadoLocal.email,
          encargado_telefono: this.encargadoLocal.telefono || 'No disponible',
          encargado_cargo: this.encargadoLocal.tipo_nombre,
          encargado_activo: this.encargadoLocal.es_activo,
          encargado_iniciales: this.encargadoLocal.iniciales,
          encargado_es_admin: this.encargadoLocal.es_administrador
        };
      }

      // Si no hay encargado cargado pero sí hay id_encargado
      if (this.local.id_encargado && !this.loadingEncargado) {
        return {
          ...localBase,
          encargado: `Cargando usuario ID: ${this.local.id_encargado}...`,
          encargado_email: 'Cargando...',
          encargado_telefono: 'Cargando...',
          encargado_cargo: 'Cargando...',
          encargado_activo: false
        };
      }

      // Fallback sin encargado
      return {
        ...localBase,
        encargado: 'Sin encargado asignado',
        encargado_email: 'No disponible',
        encargado_telefono: 'No disponible',
        encargado_cargo: 'Sin asignar',
        encargado_activo: false
      };
    },

    clienteSeleccionado() {
      return this.clientes.find(cliente => cliente.id === this.clienteSeleccionadoId) || null
    },

    empresaInfo() {
      return this.empresa || this.empresaSeleccionada
    },
    empresaLogo() {
      return this.empresa?.media || null
    },
    localInfo() {
      if (!this.local || !this.encargadoLocal) {
        return this.local;
      }

      return {
        ...this.local,
        // Datos del encargado obtenidos del backend
        encargado_local: "Pepito",
        telefono_local: this.encargadoLocal.telefono || 'No disponible',
        email_local: this.encargadoLocal.email || 'No disponible',
        // Mantener los datos originales del local
        numero_local: this.local.numero_local,
        direccion: this.local.direccion,
        media: this.local.media
      };
    },

    hayDispositivosCargados() {
      return this.equipos.length > 0
    },

    estadoConexion() {
      if (this.loadingDispositivos) return 'cargando'
      if (this.errorDispositivos) return 'error'
      if (this.hayDispositivosCargados) return 'conectado'
      return 'desconectado'
    },

    // NUEVAS COMPUTED PARA DIAGNÓSTICO
    estadoConexionTexto() {
      switch (this.estadoConexion) {
        case 'cargando': return 'Conectando...'
        case 'conectado': return 'Conectado al servidor'
        case 'error': return `Error: ${this.errorDispositivos}`
        case 'desconectado': return 'Desconectado'
        default: return 'Estado desconocido'
      }
    },

    colorEstadoConexion() {
      switch (this.estadoConexion) {
        case 'cargando': return 'text-yellow-600'
        case 'conectado': return 'text-green-600'
        case 'error': return 'text-red-600'
        case 'desconectado': return 'text-gray-600'
        default: return 'text-gray-600'
      }
    },

    iconoEstadoConexion() {
      switch (this.estadoConexion) {
        case 'cargando': return 'animate-spin'
        case 'conectado': return 'animate-pulse'
        case 'error': return 'text-red-500'
        default: return 'text-gray-500'
      }
    },

    ultimaActualizacionFormateada() {
      if (!this.ultimaActualizacion) return 'Nunca'
      return new Date(this.ultimaActualizacion).toLocaleString('es-CL')
    },

    puedeReintentar() {
      return this.errorDispositivos && !this.loadingDispositivos && this.reintentoCount < this.maxRetryAttempts
    },

    infoDebug() {
      return {
        totalEquipos: this.equipos.length,
        ultimaActualizacion: this.ultimaActualizacionFormateada,
        erroresConsecutivos: this.errorConsecutivos,
        autoUpdateEnabled: this.autoUpdateEnabled,
        estadoConexion: this.estadoConexion,
        conexionTiempoReal: this.conexionTiempoReal,
        ultimoHeartbeat: this.ultimoHeartbeat ? new Date(this.ultimoHeartbeat).toLocaleTimeString() : 'N/A'
      }
    }
  },

  watch: {
    local: {
      async handler(newLocal, oldLocal) {
        if (newLocal && newLocal !== oldLocal) {

          // CARGAR DATOS DEL ENCARGADO PRINCIPAL
          if (newLocal.id_encargado) {
            await this.cargarEncargadoDelLocal(newLocal.id_encargado);
          } else {
            this.encargadoLocal = null;
          }

          // CARGAR ENCARGADOS EXTRAS DEL LOCAL
          await this.cargarEncargadosExtrasDelLocal();

          // RECARGAR DISPOSITIVOS DEL NUEVO LOCAL
          if (newLocal.id) {
            await this.inicializarDispositivosDelLocal(newLocal.id);
          }
        }
      },
      immediate: false
    },

    empresa: {
      handler(newEmpresa, oldEmpresa) {
        if (newEmpresa && newEmpresa !== oldEmpresa) {
          this.empresaSeleccionada = newEmpresa
        }
      },
      immediate: false
    },

    errorConsecutivos(count) {
      if (count >= this.maxRetryAttempts && this.equipos.length === 0) {
        // Ya no se activa el modo fallback, simplemente se muestra el error.
      }
    }
  },

  async mounted() {
    this.configurarListenerClicksFuera()

    // CONFIGURAR EMPRESA SELECCIONADA
    if (this.empresa) {
      this.empresaSeleccionada = this.empresa
    }

    // CARGAR ENCARGADO PRINCIPAL
    if (this.local && this.local.id_encargado) {
      await this.cargarEncargadoDelLocal(this.local.id_encargado)
    }

    // CARGAR ENCARGADOS EXTRAS
    if (this.local && this.local.id) {
      await this.cargarEncargadosExtrasDelLocal()
    }

    if (this.local && this.local.id_encargado) {
      await this.cargarEncargadoDelLocal(this.local.id_encargado)
    }

    // DEBUG DE IMÁGENES EN DESARROLLO
    if (this.debugMode) {
      this.verificarAssets()
    }

    //   CARGAR DISPOSITIVOS DEL LOCAL ESPECÍFICO (CRÍTICO)
    if (this.local && this.local.id) {
      await this.inicializarDispositivosDelLocal(this.local.id)
    } else {
      await this.inicializarDispositivos()
    }

    // DEBUG DE IMÁGENES DESPUÉS DE CARGAR DISPOSITIVOS
    if (this.debugMode) {
      this.debugImagenes()
      this.debugFlujoImagenes()
    }

    // CONFIGURAR ACTUALIZACIÓN AUTOMÁTICA
    if (this.autoUpdateEnabled) {
      this.configurarActualizacionAutomatica()
    }

    // CONFIGURAR HEARTBEAT PARA TIEMPO REAL
    this.configurarHeartbeat()
  },

  beforeUnmount() {
    //   LIMPIAR LISTENER DE TECLADO
    this.limpiarListenerClicksFuera()
    // LIMPIAR INTERVALOS
    if (this.updateInterval) {
      clearInterval(this.updateInterval)
    }

    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval)
    }
  },

  methods: {
    // ---------------------------------------------------
    // Gestión de Modales
    // ---------------------------------------------------
    // Abre modal para añadir nuevo dispositivo
    handleAnadirDispositivo() {
      this.showDispositivosModal = true
    },
    // Maneja creación exitosa de dispositivo
    onDispositivoCreado(nuevoDispositivo) {
      this.showDispositivosModal = false
      const dispositivoConImagen = {
        ...nuevoDispositivo,
        imagen: this.resolverImagen(nuevoDispositivo.imagen)
      }
      this.equipos.push(dispositivoConImagen)
      toast.success(`Dispositivo "${nuevoDispositivo.nombre_dispositivo}" creado exitosamente`)
    },
    // Abre modal de alarmas del dispositivo
    abrirModalAlarmas() {
      this.modalAlarmasAbierto = true
    },
    // Cierra modal de alarmas
    cerrarModalAlarmas() {
      this.modalAlarmasAbierto = false
    },
    // Abre modal de configuración de horarios
    abrirModalHorario() {
      this.modalHorarioAbierto = true
    },
    // Cierra modal de horarios
    cerrarModalHorario() {
      this.modalHorarioAbierto = false
    },
    // Abre modal de detalle del equipo
    async abrirDetalleEquipo(equipoId) {
      try {
        const indiceEncontrado = this.equipos.findIndex(e => e.id === equipoId)
        if (indiceEncontrado === -1) {
          throw new Error(`Equipo con ID ${equipoId} no encontrado en la lista`)
        }
        this.indiceEquipoActual = indiceEncontrado
        this.navegacionHistorial.push({
          equipoId: equipoId,
          timestamp: Date.now(),
          indice: indiceEncontrado
        })

        // 1. Mostrar la UI inmediatamente con datos cacheados para evitar bloqueos
        const equipoCacheado = this.equipos[indiceEncontrado]
        await this.actualizarEquipoSeleccionado(equipoCacheado)
        this.modalAbierto = true
        document.body.style.overflow = 'hidden'

        // 2. Cargar en segundo plano para no congelar la pantalla
        this.obtenerEquipoDetallado(equipoId).then(equipoFresco => {
          if (this.equipoSeleccionado && this.equipoSeleccionado.id === equipoId) {
            this.actualizarEquipoSeleccionado(equipoFresco)
          }
        }).catch(err => console.log('Carga en segundo plano ignorada por saturación:', err))

      } catch (error) {
        toast.warning(`Error cargando detalles: ${error.message}`)
      }
    },
    // Cierra modal principal y limpia navegación
    cerrarModal() {
      // Forzar la cancelación del gráfico directamente desde el padre
      if (this.$refs.graficoHistorial && this.$refs.graficoHistorial.cancelarPeticionSilenciosa) {
        this.$refs.graficoHistorial.cancelarPeticionSilenciosa()
      }

      this.modalAbierto = false
      document.body.style.overflow = 'auto'
      this.indiceEquipoActual = -1
      this.limpiarHistorialNavegacion()
      this.cargandoNavegacion = false
    },
    // ---------------------------------------------------
    // Gestión de Dispositivos (CRUD)
    // ---------------------------------------------------
    // Filtros para la tabla de dispositivo
    cambiarOrden(columna) {
      if (this.columnaOrden === columna) {
        this.ordenDescendente = !this.ordenDescendente;
      } else {
        this.columnaOrden = columna;
        this.ordenDescendente = false;
      }
    },

    toggleDropdown(tipo) {
      this.dropdownOpen[tipo] = !this.dropdownOpen[tipo];
    },

    selectOption(tipo, valor) {
      if (tipo === 'estado') {
        this.filtroEstado = valor;
      }
      this.dropdownOpen[tipo] = false;
    },

    clearAllFilters() {
      this.searchText = '';
      this.filtroEstado = 'TODOS';
      this.dropdownOpen.estado = false;
    },

    cerrarDropdownsClickFuera(event) {
      if (!event.target.closest('.dropdown-container')) {
        this.dropdownOpen.estado = false;
      }
    },
    // Actualiza imagen del dispositivo
    async actualizarImagenDispositivo(archivoImagen) {
      if (!this.equipoSeleccionado?.id) {
        return
      }
      try {
        const datosDispositivo = {
          nombre_dispositivo: this.equipoSeleccionado.nombre_dispositivo,
          local_id: this.equipoSeleccionado.local_id,
          modelo_dispositivo: this.equipoSeleccionado.modelo_dispositivo,
          marca_dispositivo: this.equipoSeleccionado.marca_dispositivo,
          fabricante: this.equipoSeleccionado.fabricante,
          ubicacion_dispositivo: this.equipoSeleccionado.ubicacion_dispositivo,
          activo_dispositivo: this.equipoSeleccionado.activo_dispositivo,
          fecha_instalacion: this.equipoSeleccionado.fecha_instalacion,
          equipo_id: this.equipoSeleccionado.equipo?.id || null,
          broker_config: this.equipoSeleccionado.broker_config || null
        };
        const dispositivoActualizado = await DispositivosService.actualizarDispositivo(
          this.equipoSeleccionado.id,
          datosDispositivo,
          archivoImagen,
          false
        )
        await this.actualizarEquipoSeleccionado(dispositivoActualizado)
        const index = this.equipos.findIndex(e => e.id === dispositivoActualizado.id)
        if (index !== -1) {
          this.equipos[index] = {
            ...dispositivoActualizado,
            imagen: this.resolverImagen(dispositivoActualizado.imagen)
          }
        }
        toast.success('Imagen del dispositivo actualizada correctamente')
      } catch (error) {
        toast.error(`Error al actualizar la imagen: ${error.message}`)
      }
    },
    // Elimina imagen del dispositivo
    async eliminarImagenDispositivo() {
      if (!this.equipoSeleccionado?.id) {
        return
      }
      try {
        const datosDispositivo = {
          nombre_dispositivo: this.equipoSeleccionado.nombre_dispositivo,
          local_id: this.equipoSeleccionado.local_id,
          modelo_dispositivo: this.equipoSeleccionado.modelo_dispositivo,
          marca_dispositivo: this.equipoSeleccionado.marca_dispositivo,
          fabricante: this.equipoSeleccionado.fabricante,
          ubicacion_dispositivo: this.equipoSeleccionado.ubicacion_dispositivo,
          activo_dispositivo: this.equipoSeleccionado.activo_dispositivo,
          fecha_instalacion: this.equipoSeleccionado.fecha_instalacion,
          equipo_id: this.equipoSeleccionado.equipo?.id || null,
          broker_config: this.equipoSeleccionado.broker_config || null
        };
        const dispositivoActualizado = await DispositivosService.actualizarDispositivo(
          this.equipoSeleccionado.id,
          datosDispositivo,
          null,
          true
        )
        await this.actualizarEquipoSeleccionado(dispositivoActualizado)
        const index = this.equipos.findIndex(e => e.id === dispositivoActualizado.id)
        if (index !== -1) {
          this.equipos[index] = {
            ...dispositivoActualizado,
            imagen: this.resolverImagen(dispositivoActualizado.imagen)
          }
        }
        toast.success('Imagen eliminada correctamente')
      } catch (error) {
        toast.error(`Error al actualizar la imagen: ${error.message}`)
      }
    },
    // Maneja actualización de campos editables del dispositivo
    async manejarCampoGuardado(evento) {
      const { campo, valor } = evento
      try {
        const dispositivoActualizado = await DispositivosService.actualizarDispositivo(
          this.equipoSeleccionado.id,
          { [campo]: valor }
        )
        this.equipoSeleccionado = dispositivoActualizado
        const index = this.equipos.findIndex(e => e.id === dispositivoActualizado.id)
        if (index !== -1) {
          this.equipos[index] = {
            ...dispositivoActualizado,
            imagen: this.resolverImagen(dispositivoActualizado.imagen)
          }
        }
      } catch (error) {
        toast.error(`Error al actualizar ${this.obtenerNombreAmigableCampo(campo)}: ${error.message}`)
      }
    },
    // Guarda nuevo nombre del dispositivo
    async guardarNombreDispositivo(nuevoNombre) {
      this.guardandoNombre = true
      try {
        await DispositivosService.actualizarNombreDispositivo(
          this.equipoSeleccionado.id,
          nuevoNombre
        )
        this.equipoSeleccionado.nombre_dispositivo = nuevoNombre
        this.equipoSeleccionado.nombre = nuevoNombre
        const index = this.equipos.findIndex(e => e.id === this.equipoSeleccionado.id)
        if (index !== -1) {
          this.equipos[index].nombre_dispositivo = nuevoNombre
          this.equipos[index].nombre = nuevoNombre
        }
        this.editandoNombre = false
        this.$refs.modalDetalleDispositivo.cancelarEdicionNombre()
      } catch (error) {
        toast.error(`Error guardando nombre: ${error.message}`)
      } finally {
        this.guardandoNombre = false
      }
    },
    // Guarda nueva ubicación del dispositivo
    async guardarUbicacionDispositivo(nuevaUbicacion) {
      try {
        await DispositivosService.actualizarUbicacionDispositivo(
          this.equipoSeleccionado.id,
          nuevaUbicacion
        )
        this.equipoSeleccionado.ubicacion_dispositivo = nuevaUbicacion
        this.equipoSeleccionado.ubicacion = nuevaUbicacion
        const index = this.equipos.findIndex(e => e.id === this.equipoSeleccionado.id)
        if (index !== -1) {
          this.equipos[index].ubicacion_dispositivo = nuevaUbicacion
          this.equipos[index].ubicacion = nuevaUbicacion
        }
      } catch (error) {
        toast.warning(`Error guardando ubicación: ${error.message}`)
      }
    },
    // ---------------------------------------------------
    // Gestión de Alarmas
    // ---------------------------------------------------
    // Maneja selección de alarma en el modal
    onAlarmaSeleccionada() {
    },
    // Maneja alarma resuelta
    onAlarmaResuelta() {
    },
    // Maneja errores del componente de alarmas
    onErrorAlarmas() {
    },
    // ---------------------------------------------------
    // Gestión de GPS y Locales
    // ---------------------------------------------------
    // Maneja carga exitosa del GPS
    onGPSLoaded() {
    },
    // Maneja errores del GPS
    onGPSError() {
    },
    // Maneja ubicación compartida
    onLocationShared() {
    },
    // Maneja solicitud de edición de local
    onEditLocalRequested() {
    },
    // Maneja solicitud de ayuda
    onHelpRequested() {
      toast.info('Para agregar dirección GPS:\n1. Ve a gestión de locales\n2. Edita el local\n3. Agrega la dirección completa')
    },
    // ---------------------------------------------------
    // Gestión de Encargados
    // ---------------------------------------------------
    // Carga encargado del local usando servicio
    async cargarEncargadoDelLocal(encargadoId) {
      if (!encargadoId || this.loadingEncargado) return
      if (this.encargadosCache.has(encargadoId)) {
        this.encargadoLocal = this.encargadosCache.get(encargadoId)
        return
      }
      this.loadingEncargado = true
      this.errorEncargado = null
      try {
        const encargado = await UsuariosService.obtenerUsuarioPorId(encargadoId)
        this.encargadoLocal = encargado
        this.encargadosCache.set(encargadoId, encargado)
      } catch (error) {
        this.errorEncargado = error.message
        this.encargadoLocal = {
          id: encargadoId,
          nombre_completo: `Usuario ID: ${encargadoId}`,
          email: 'No disponible',
          telefono: 'No disponible',
          tipo_nombre: 'Encargado Local',
          es_activo: false,
          iniciales: 'U?',
          es_administrador: false,
          _fuente: 'fallback'
        }
      } finally {
        this.loadingEncargado = false
      }
    },
    // Carga múltiples encargados de forma optimizada
    async cargarMultiplesEncargados(encargadoIds) {
      if (!encargadoIds || encargadoIds.length === 0) return {}
      try {
        const encargados = await UsuariosService.obtenerUsuariosPorIds(encargadoIds)
        const mapaEncargados = {}
        encargados.forEach(encargado => {
          mapaEncargados[encargado.id] = encargado
          this.encargadosCache.set(encargado.id, encargado)
        })
        return mapaEncargados
      } catch (error) {
        return {}
      }
    },
    // Busca encargados por nombre/email
    async buscarEncargados(texto) {
      if (!texto || texto.length < 2) return []
      try {
        const encargadosEncontrados = await UsuariosService.buscarUsuarios(texto, 'ENCARGADO')
        return encargadosEncontrados
      } catch (error) {
        return []
      }
    },
    // ---------------------------------------------------
    // Gestión de Encargados Extras del Local
    // ---------------------------------------------------
    /**
     * Carga todos los encargados extras del local actual
     */
    async cargarEncargadosExtrasDelLocal() {
      if (!this.local || !this.local.id) {
        this.encargadosExtrasDelLocal = []
        return
      }

      if (this.loadingEncargadosExtras) {
        return
      }

      this.loadingEncargadosExtras = true
      this.errorEncargadosExtras = null

      try {
        const encargados = await EncargadosExtrasService.obtenerEncargadosPorLocal(this.local.id)
        this.encargadosExtrasDelLocal = encargados

      } catch (error) {
        this.errorEncargadosExtras = error.message
        this.encargadosExtrasDelLocal = []
      } finally {
        this.loadingEncargadosExtras = false
      }
    },
    // ---------------------------------------------------
    // Navegación entre Equipos
    // ---------------------------------------------------
    // Navega al equipo anterior en el modal
    async verEquipoAnterior() {
      if (!this.hayEquipoAnterior) return

      if (this.$refs.graficoHistorial && this.$refs.graficoHistorial.cancelarPeticionSilenciosa) {
        this.$refs.graficoHistorial.cancelarPeticionSilenciosa()
      }

      try {
        const nuevoIndice = this.indiceEquipoActual - 1
        const equipoAnterior = this.equipos[nuevoIndice]
        this.indiceEquipoActual = nuevoIndice

        await this.actualizarEquipoSeleccionado(equipoAnterior)

        this.navegacionHistorial.push({
          equipoId: equipoAnterior.id,
          timestamp: Date.now(),
          indice: nuevoIndice,
          accion: 'anterior'
        })

        this.obtenerEquipoDetallado(equipoAnterior.id).then(equipoDetallado => {
          if (this.equipoSeleccionado && this.equipoSeleccionado.id === equipoAnterior.id) {
            this.actualizarEquipoSeleccionado(equipoDetallado)
          }
        }).catch(err => console.log('Fetch secundario ignorado:', err))

      } catch (error) {
        toast.error(`Error de navegación: ${error.message}`)
      }
    },
    // Navega al equipo siguiente en el modal
    async verEquipoSiguiente() {
      if (!this.hayEquipoSiguiente) return

      if (this.$refs.graficoHistorial && this.$refs.graficoHistorial.cancelarPeticionSilenciosa) {
        this.$refs.graficoHistorial.cancelarPeticionSilenciosa()
      }

      try {
        const nuevoIndice = this.indiceEquipoActual + 1
        const equipoSiguiente = this.equipos[nuevoIndice]
        this.indiceEquipoActual = nuevoIndice

        await this.actualizarEquipoSeleccionado(equipoSiguiente)

        this.navegacionHistorial.push({
          equipoId: equipoSiguiente.id,
          timestamp: Date.now(),
          indice: nuevoIndice,
          accion: 'siguiente'
        })

        this.obtenerEquipoDetallado(equipoSiguiente.id).then(equipoDetallado => {
          if (this.equipoSeleccionado && this.equipoSeleccionado.id === equipoSiguiente.id) {
            this.actualizarEquipoSeleccionado(equipoDetallado)
          }
        }).catch(err => console.log('Fetch secundario ignorado:', err))

      } catch (error) {
        toast.error(`Error de navegación: ${error.message}`)
      }
    },
    // Navega directamente a un equipo por índice
    async irAEquipoPorIndice(indice) {
      if (indice < 0 || indice >= this.equipos.length) return

      if (this.$refs.graficoHistorial && this.$refs.graficoHistorial.cancelarPeticionSilenciosa) {
        this.$refs.graficoHistorial.cancelarPeticionSilenciosa()
      }

      try {
        const equipo = this.equipos[indice]
        this.indiceEquipoActual = indice

        await this.actualizarEquipoSeleccionado(equipo)

        this.obtenerEquipoDetallado(equipo.id).then(equipoDetallado => {
          if (this.equipoSeleccionado && this.equipoSeleccionado.id === equipo.id) {
            this.actualizarEquipoSeleccionado(equipoDetallado)
          }
        }).catch(err => console.log('Fetch secundario ignorado:', err))

      } catch (error) {
        console.error(error)
      }
    },
    // ---------------------------------------------------
    // Gestión de Configuración de Horarios
    // ---------------------------------------------------
    // Guarda configuración de horarios
    guardarConfiguracionHorarios(configuracion) {
      this.configuracionHorarios = { ...configuracion.configuracion }
      toast.success('Horarios guardados correctamente')
    },
    // ---------------------------------------------------
    // Gestión de Eliminación de Dispositivos
    // ---------------------------------------------------
    /**
     * Inicia el proceso de eliminación de un dispositivo
     */
    async iniciarEliminacionDispositivo(dispositivo) {
      this.dispositivoToDelete = dispositivo
      this.deleteInfo = null
      this.deleteConfirmationText = ''
      this.loadingDeleteInfo = true
      this.showDeleteModal = true

      try {
        this.deleteInfo = await DispositivosService.obtenerInfoEliminacion(dispositivo.id)
      } catch (error) {
        toast.error(`Error verificando dispositivo: ${error.message}`)
        this.hideDeleteModal()
      } finally {
        this.loadingDeleteInfo = false
      }
    },

    /**
     * Confirma y ejecuta la eliminación del dispositivo
     */
    async confirmarEliminacion() {
      if (!this.isDeleteConfirmationValid) {
        toast.info('Por favor confirma escribiendo el nombre del dispositivo correctamente')
        return
      }

      this.processingDelete = true

      try {

        await DispositivosService.eliminarDispositivo(this.dispositivoToDelete.id)


        // Mostrar mensaje de éxito
        toast.warning(
          `Dispositivo "${this.dispositivoToDelete.nombre_dispositivo}" eliminado exitosamente.\n\n` +
          `La eliminación es definitiva y no se puede deshacer.`
        )

        // Cerrar modal
        this.hideDeleteModal()

        // Recargar lista de dispositivos
        if (this.local && this.local.id) {
          await this.inicializarDispositivosDelLocal(this.local.id)
        } else {
          await this.inicializarDispositivos()
        }

      } catch (error) {
        toast.error(`Error eliminando dispositivo: ${error.message}`)
      } finally {
        this.processingDelete = false
      }
    },

    /**
     * Cierra el modal de eliminación y resetea el estado
     */
    hideDeleteModal() {
      this.showDeleteModal = false
      this.resetDeleteForm()
    },

    /**
     * Resetea el formulario de eliminación
     */
    resetDeleteForm() {
      this.deleteInfo = null
      this.dispositivoToDelete = null
      this.deleteConfirmationText = ''
      this.processingDelete = false
      this.loadingDeleteInfo = false
    },
    // ---------------------------------------------------
    // Control de Dispositivos (Encendido/Temperatura)
    // ---------------------------------------------------
    // Cambia estado de encendido/apagado del dispositivo
    async togglePower(nuevoEstado) {
      const estadoAEstablecer = nuevoEstado !== undefined ?
        nuevoEstado : !this.equipoSeleccionado.encendido
      const dispositivoId = this.equipoSeleccionado.id
      try {
        const dispositivoActualizado = await DispositivosService.cambiarEstadoDispositivo(
          dispositivoId,
          estadoAEstablecer
        )
        this.equipoSeleccionado.encendido = estadoAEstablecer
        this.equipoSeleccionado.activo_dispositivo = estadoAEstablecer
        const index = this.equipos.findIndex(e => e.id === dispositivoId)
        if (index !== -1) {
          this.equipos[index] = {
            ...dispositivoActualizado,
            imagen: this.resolverImagen(dispositivoActualizado.imagen)
          }
        }
      } catch (error) {
        this.equipoSeleccionado.encendido = !estadoAEstablecer
        this.equipoSeleccionado.activo_dispositivo = !estadoAEstablecer
        toast.error(`Error: ${error.message}`)
      }
    },
    // Actualiza temperatura objetivo del dispositivo
    async actualizarTemperaturaObjetivo(nuevaTemp) {
      try {
        const row = this.equipoSeleccionado.dispositivo_sensores?.find(
          (r) => (r.sensor?.clave_broker || "").trim() === "Setpoint"
        );

        if (row) {
          await DispositivosService.actualizarDispositivoSensor(row.id, { valor_actual: nuevaTemp });

          this.equipoSeleccionado.tempObjetivo = nuevaTemp;
          row.valor_actual = nuevaTemp;

          const index = this.equipos.findIndex(e => e.id === this.equipoSeleccionado.id);
          if (index !== -1) {
            const equipoEnLista = this.equipos[index];
            const rowEnLista = equipoEnLista.dispositivo_sensores?.find(
              (r) => (r.sensor?.clave_broker || "").trim() === "Setpoint"
            );
            if (rowEnLista) rowEnLista.valor_actual = nuevaTemp;
          }
        } else {
          toast.warning("No se encontró el sensor Setpoint en el equipo");
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`);
      }
    },
    // Incrementa temperatura objetivo
    async incrementTemp() {
      if (this.equipoSeleccionado.tempObjetivo < 30) {
        const nuevaTemp = this.equipoSeleccionado.tempObjetivo + 1
        await this.actualizarTemperaturaObjetivo(nuevaTemp)
      }
    },
    // Decrementa temperatura objetivo
    async decrementTemp() {
      if (this.equipoSeleccionado.tempObjetivo > 10) {
        const nuevaTemp = this.equipoSeleccionado.tempObjetivo - 1
        await this.actualizarTemperaturaObjetivo(nuevaTemp)
      }
    },
    // ---------------------------------------------------
    // Inicialización y Conexión de Datos
    // ---------------------------------------------------
    refrescarOperatividadPlano() {
      if (this.$refs.planoLocalRef) {
        this.$refs.planoLocalRef.actualizarVistaOperatividad();
      }
    },
    // renderizado seguro de temperaturas
    obtenerTemperaturaRender(equipo, llaveSensor) {
      const s = sensorMap(equipo);
      const valor = getNumber(s, llaveSensor, equipo.configuracion_dispositivo?.[llaveSensor] ?? null);
      return valor != null ? `${Math.round(valor * 10) / 10}°C` : '--°C';
    },
    // Inicializa dispositivos desde el backend con filtro por local
    async inicializarDispositivosDelLocal(localId) {
      this.loadingDispositivos = true
      this.errorDispositivos = null
      try {
        const dispositivosDelLocal = await DispositivosService.obtenerDispositivosPorLocal(localId)

        const dispositivosConImagenes = dispositivosDelLocal.map((dispositivo) => {
          const imagenResuelta = this.resolverImagen(dispositivo.imagen)
          return {
            ...dispositivo,
            imagen_original: dispositivo.imagen,
            imagen: imagenResuelta
          }
        })
        this.equipos = dispositivosConImagenes
        this.ultimaActualizacion = new Date()
        this.errorConsecutivos = 0
        this.conexionTiempoReal = true
      } catch (error) {
        this.errorDispositivos = error.message
        this.errorConsecutivos++
        this.conexionTiempoReal = false
        if (this.errorConsecutivos >= this.maxRetryAttempts) {
          // Límite de reintentos alcanzado
        }
      } finally {
        this.loadingDispositivos = false
        this.tiempoUltimaCarga = new Date()
      }
    },
    // Inicializar dispositivos sin filtro (fallback)
    async inicializarDispositivos() {
      this.loadingDispositivos = true
      this.errorDispositivos = null
      try {
        const todosLosDispositivos = await DispositivosService.obtenerTodosLosDispositivos()

        const dispositivosConImagenes = todosLosDispositivos.map((dispositivo) => {
          const imagenResuelta = this.resolverImagen(dispositivo.imagen)
          return {
            ...dispositivo,
            imagen_original: dispositivo.imagen,
            imagen: imagenResuelta
          }
        })
        this.equipos = dispositivosConImagenes
        this.ultimaActualizacion = new Date()
        this.errorConsecutivos = 0
        this.conexionTiempoReal = true
      } catch (error) {
        this.errorDispositivos = error.message
        this.errorConsecutivos++
        this.conexionTiempoReal = false
      } finally {
        this.loadingDispositivos = false
        this.tiempoUltimaCarga = new Date()
      }
    },
    // Actualización silenciosa de dispositivos para auto-refresh
    async actualizarDispositivosSilencioso() {
      try {
        let dispositivosActualizados
        if (this.local && this.local.id) {
          dispositivosActualizados = await DispositivosService.obtenerDispositivosPorLocal(this.local.id)
        } else {
          dispositivosActualizados = await DispositivosService.obtenerTodosLosDispositivos()
        }
        const dispositivosConImagenes = dispositivosActualizados.map((dispositivo) => {
          const imagenResuelta = this.resolverImagen(dispositivo.imagen)
          return {
            ...dispositivo,
            imagen_original: dispositivo.imagen,
            imagen: imagenResuelta
          }
        })
        const hayDiferencias = this.compararEquipos(dispositivosConImagenes, this.equipos)
        if (hayDiferencias) {
          this.equipos = dispositivosConImagenes
          this.ultimaActualizacion = new Date()
          if (this.modalAbierto && this.equipoSeleccionado.id) {
            await this.actualizarEquipoSeleccionado()
          }
        }
        this.errorConsecutivos = 0
        this.conexionTiempoReal = true
        this.ultimoHeartbeat = new Date()
      } catch (error) {
        this.errorConsecutivos++
        this.conexionTiempoReal = false
      }
    },
    // ---------------------------------------------------
    // Gestión de Imágenes y Assets
    // ---------------------------------------------------
    // Resuelve imagen según nombre con logs detallados para debug
    resolverImagen(nombreImagen) {
      if (!nombreImagen || nombreImagen === 'null' || nombreImagen === 'undefined') {
        return ImagenDefault
      }
      if (typeof nombreImagen === 'string' && (nombreImagen.startsWith('http') || nombreImagen.includes('/media/'))) {
        return nombreImagen
      }
      return ImagenDefault
    },
    // ---------------------------------------------------
    // Gestión de Eventos de UI
    // ---------------------------------------------------
    // Configura listener para clicks fuera de áreas de edición
    configurarListenerClicksFuera() {
      document.addEventListener('click', this.manejarClickFuera, true)
    },
    // Maneja clicks fuera del área de edición
    manejarClickFuera(event) {
      if (!this.editandoNombre) return
      const areaEdicion = document.querySelector('.relative')
      const mensajeInfo = event.target.closest('.text-sm.text-gray-600')
      if (areaEdicion && !areaEdicion.contains(event.target) && !mensajeInfo) {
        this.$refs.modalDetalleDispositivo && this.$refs.modalDetalleDispositivo.cancelarEdicionActiva()
      }
    },
    // Limpia listener de clicks al desmontar
    limpiarListenerClicksFuera() {
      document.removeEventListener('click', this.manejarClickFuera, true)
    },
    // ---------------------------------------------------
    // Utilidades y Formateo
    // ---------------------------------------------------
    /**
     * Formatea número telefónico chileno al estilo +56 9 1234 5678
     * @param {string} telefono - Número sin formato
     * @returns {string} Número formateado
     */
    formatearTelefono(telefono) {
      if (!telefono) return 'No disponible'

      // Limpiar cualquier carácter que no sea número o +
      let digitos = telefono.replace(/[^\d+]/g, '')

      // Si no tiene dígitos, retornar como está
      if (digitos.length === 0) return telefono

      // Formato chileno: +56 9 1234 5678
      if (digitos.startsWith('+56') || digitos.startsWith('56')) {
        // Asegurar que empiece con +56
        if (!digitos.startsWith('+')) {
          if (digitos.startsWith('56')) {
            digitos = '+' + digitos
          } else {
            digitos = '+56' + digitos
          }
        }

        // Aplicar formato: +56 9 1234 5678
        let formatted = ''

        // +56
        formatted = digitos.substring(0, 3) // +56

        // Espacio + siguiente dígito (generalmente el 9)
        if (digitos.length > 3) {
          formatted += ' ' + digitos.substring(3, 4) // 9
        }

        // Espacio + siguientes 4 dígitos
        if (digitos.length > 4) {
          formatted += ' ' + digitos.substring(4, 8) // 1234
        }

        // Espacio + últimos 4 dígitos
        if (digitos.length > 8) {
          formatted += ' ' + digitos.substring(8, 12) // 5678
        }

        return formatted
      }

      // Si no es formato chileno, retornar con espacios cada 4 dígitos
      return digitos.replace(/(\d{4})(?=\d)/g, '$1 ')
    },
    // Obtiene datos detallados de un equipo específico
    async obtenerEquipoDetallado(equipoId) {
      try {
        const equipoDetallado = await DispositivosService.obtenerDispositivoPorId(equipoId)
        const equipoConImagen = {
          ...equipoDetallado,
          imagen_original: equipoDetallado.imagen,
          imagen: this.resolverImagen(equipoDetallado.imagen)
        }
        return equipoConImagen
      } catch (error) {
        return this.equipos.find(e => e.id === equipoId)
      }
    },
    // Actualiza equipo seleccionado mientras el modal está abierto
    async actualizarEquipoSeleccionado(equipo) {
      const s = sensorMap(equipo);
      this.equipoSeleccionado = {
        ...equipo,
        nombre: equipo.nombre_dispositivo,
        ubicacion: equipo.ubicacion_dispositivo,
        encendido: equipo.activo_dispositivo,
        modo: modoTexto(s["Modo"]),
        potenciaActiva: getNumber(s, "Temp Inyeccion", 0),
        tempRetorno: getNumber(s, "Temp Retorno", 0),
        tempObjetivo: getNumber(s, "Setpoint", 22),
        bateria: equipo.bateria || 0,
        consumo: equipo.consumo || 0,
        voltajes: equipo.voltajes || {},
        corrientes: equipo.corrientes || {},
        historialVoltajes: equipo.historialVoltajes || [],
        alertas: equipo.alertas || []
      }
    },
    // Convierte nombre técnico del campo a nombre amigable
    obtenerNombreAmigableCampo(campo) {
      const mapeoNombres = {
        'fecha_instalacion': 'Fecha de Instalación',
        'modelo_dispositivo': 'Modelo',
        'marca_dispositivo': 'Marca',
        'capacidad_frio': 'Capacidad de Frío',
        'capacidad_calor': 'Capacidad de Calor',
        'refrigerante': 'Refrigerante',
        'carga': 'Carga',
        'voltaje': 'Voltaje',
        'corriente': 'Corriente'
      }
      return mapeoNombres[campo] || campo.replace('_', ' ').toUpperCase()
    },
    // Obtiene tipo de empresa por ID
    getTipoEmpresaNombre(tipoId) {
      const tipos = {
        1: 'Tecnología',
        2: 'Retail',
        3: 'Manufactura',
        4: 'Servicios'
      }
      return tipos[tipoId] || 'Tipo Desconocido'
    },
    // ---------------------------------------------------
    // Configuración y Actualización Automática
    // ---------------------------------------------------
    // Configura actualización automática de dispositivos
    configurarActualizacionAutomatica() {
      if (this.updateInterval) {
        clearInterval(this.updateInterval)
      }
      this.updateInterval = setInterval(async () => {
        if (!this.loadingDispositivos) {
          await this.actualizarDispositivosSilencioso()
        }
      }, this.updateFrequency)
    },
    // Configura heartbeat para monitoreo de conexión
    configurarHeartbeat() {
      this.heartbeatInterval = setInterval(() => {
        const tiempoSinActualizacion = this.ultimaActualizacion ?
          Date.now() - this.ultimaActualizacion.getTime() : Infinity
        if (tiempoSinActualizacion > 120000) {
          this.conexionTiempoReal = false
        }
      }, 10000)
    },
    // ---------------------------------------------------
    // Métodos de UI y Estilos
    // ---------------------------------------------------
    // Obtiene clases CSS para bordes hover según modo
    getHoverBorderColor(modo) {
      const colors = {
        'FRIO': 'hover:border-blue-200',
        'CALOR': 'hover:border-orange-200',
        'AUTO': 'hover:border-teal-200',
        'ERROR': 'hover:border-red-200'
      }
      return colors[modo] || 'hover:border-gray-200'
    },
    // Obtiene clases CSS para botones según modo
    getButtonClasses(modo) {
      const classes = {
        'FRIO': 'bg-gradient-to-br from-blue-100 to-blue-200 focus:ring-blue-300',
        'CALOR': 'bg-gradient-to-br from-orange-100 to-orange-200 focus:ring-orange-300',
        'AUTO': 'bg-gradient-to-br from-teal-100 to-teal-200 focus:ring-teal-300',
        'ERROR': 'bg-gradient-to-br from-red-100 to-red-200 focus:ring-red-300'
      }
      return classes[modo] || 'bg-gradient-to-br from-gray-100 to-gray-200 focus:ring-gray-300'
    },
    // Obtiene clases CSS para temperatura según modo
    getTempColorClass(modo) {
      const colors = {
        'FRIO': 'bg-blue-50',
        'CALOR': 'bg-orange-50',
        'AUTO': 'bg-teal-50',
        'ERROR': 'bg-red-50'
      }
      return colors[modo] || 'bg-gray-50'
    },
    // Obtiene color de texto para temperatura según modo
    getTempTextColor(modo) {
      const colors = {
        'FRIO': 'text-blue-600',
        'CALOR': 'text-orange-600',
        'AUTO': 'text-teal-600',
        'ERROR': 'text-red-600'
      }
      return colors[modo] || 'text-gray-600'
    },
    // Obtiene clases CSS para modo de operación
    getModoColorClass(modo) {
      const colors = {
        'FRIO': 'bg-blue-500',
        'CALOR': 'bg-orange-500',
        'AUTO': 'bg-teal-500',
        'ERROR': 'bg-red-500'
      }
      return colors[modo] || 'bg-gray-500'
    },
    // ---------------------------------------------------
    // Métodos de Exportación y PDF
    // ---------------------------------------------------
    // Exporta PDF del dispositivo actual
    exportarPDF() {
    },
    // ---------------------------------------------------
    // Métodos de Debugging y Monitoreo
    // ---------------------------------------------------
    // Verifica que las rutas de assets existan
    verificarAssets() {
      // Método vacío por petición de limpieza
    },
    // Debug de imágenes disponibles
    debugImagenes() {
      // Método vacío por petición de limpieza
    },
    // Debug del flujo completo de imágenes
    debugFlujoImagenes() {
      // Método vacío por petición de limpieza
    },
    // Verifica punto exacto de transformación de imágenes
    debugPuntoTransformacion() {
      // Método vacío por petición de limpieza
    },
    // ---------------------------------------------------
    // Métodos Auxiliares
    // ---------------------------------------------------
    // Limpia historial de navegación
    limpiarHistorialNavegacion() {
      this.navegacionHistorial = []
    },
    // Compara arrays de equipos para detectar cambios
    compararEquipos(nuevos, actuales) {
      if (nuevos.length !== actuales.length) return true
      return nuevos.some((nuevo, index) => {
        const actual = actuales[index]
        if (!actual) return true
        return (
          nuevo.activo_dispositivo !== actual.activo_dispositivo ||
          nuevo.nombre_dispositivo !== actual.nombre_dispositivo ||
          nuevo.ubicacion_dispositivo !== actual.ubicacion_dispositivo ||
          JSON.stringify(nuevo.dispositivo_sensores) !== JSON.stringify(actual.dispositivo_sensores)
        )
      })
    },
    // Maneja cambio de cliente seleccionado
    async onClienteChange() {
      if (!this.clienteSeleccionadoId) return
      this.loading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
      } catch (error) {
        // Error silencioso
      } finally {
        this.loading = false
      }
    },
    // Reintenta conexión manualmente
    async reintentarConexion() {
      this.reintentoCount++
      if (this.local && this.local.id) {
        await this.inicializarDispositivosDelLocal(this.local.id)
      } else {
        await this.inicializarDispositivos()
      }
    },
    // ---------------------------------------------------
    // Métodos de Gráficos
    // ---------------------------------------------------
    // Maneja datos filtrados del gráfico
    onGraficoDatosFiltrados() {
    },
    // Maneja variable seleccionada en gráfico
    onGraficoVariableSeleccionada() {
    },
    // Maneja solicitud de exportación de gráfico
    onGraficoExportarSolicitado() {
    }
  }
}
</script>

<style scoped>
.modal-open {
  overflow: hidden;
}
</style>